import { useHistory } from "react-router-dom";
import { useWeb3Modal } from '@web3modal/wagmi/react'
import toast, { Toaster } from "react-hot-toast";
import { useAccount } from 'wagmi'


function ConnectButton() {

 

    const { open } = useWeb3Modal();
    const { address, isConnected } = useAccount();
 
    
 
    return (
      <>
           <a className="wallet-btn" href="#" onClick={()=>{
           open();
           }}>
                   <span>  
				   {isConnected ? ((address).substring(0, 8) + "..." + (address).substring((address).length - 4)) : "Connect Wallet"}
                 </span> <i className="fa-solid fa-wallet" />
           </a>
      </>
    );
  }
  
  export default ConnectButton;
  